
import { RedirectError } from '@/core/http/redirect.interceptor';
import { hardRedirect, maybeSoftRedirect } from '@/core/navigation/redirect.service';
import siteContextStore from '@/shared/content/site-context.store';
import { LinkModel } from '@/types/B2BcontentServerContract';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import HttpStatus from 'http-status-codes';
import authStore from './auth.store';

export interface RetryUnauthorizedRequest extends AxiosRequestConfig {
    _retryUnauthorizedRequest?: boolean;
}

const responseHandler = async(response: AxiosResponse) => {
    const accessToken = authStore.accessToken;
    const originalRequest: RetryUnauthorizedRequest = response.config;
    if ((response.status === HttpStatus.UNAUTHORIZED || response.status === HttpStatus.FORBIDDEN) && accessToken) {
        // We got a 401 or 403, used to have a token and not in a retry loop, so lets fetch a new token and retry the rejected request
        if (originalRequest._retryUnauthorizedRequest) {
            // we have retired once - but still gets an UNAUTHORIZED or FORBIDDEN
            hardRedirect(response.data.returnUrl || siteContextStore.settings.loginLink.url);
        } else {
            originalRequest._retryUnauthorizedRequest = true;
            try {
                await authStore.tryRefreshExpiredAccessToken();
                return await axios.request(originalRequest);
            } catch {
                redirectUserNotAuthenticated(response);
            }
        }
    }
    return response;
};

const requestHandler = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = authStore.accessToken;
    const disableAuth = config.headers?.Authorization === '' ?? false;
    if (disableAuth) {
        delete config.headers.Authorization;
    } else if (token) {
        const authTokenString = `Bearer ${token}`;
        config.headers.Authorization = authTokenString;
    }
    return config;
};

const redirectUserNotAuthenticated = (response) => {
    const redirectLink: LinkModel = response.data?.link?.url ? response.data.link : siteContextStore.settings.loginLink;
    maybeSoftRedirect(redirectLink);
    throw new RedirectError();
};

export {
    requestHandler,
    responseHandler,
};
